export default "__VITE_ASSET__iNt8cogE__"